import {
  WithLightTitle,
  TextArea as TextAreaComponent,
} from '@randstad-lean-mobile-factory/react-components-core';
import classnames from 'classnames';
import { FieldValues, FieldPath, useController } from 'react-hook-form';

import { pluralFormat } from '../../Utils/pluralFormat';
import { ErrorMessage } from '../ErrorMessage';

import styles from './TextAreaWithLightTitle.module.scss';
import { TextAreaWithLightTitleProps } from './TextAreaWithLightTitle.types';

export const TextAreaWithLightTitle = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  title,
  control,
  name,
  defaultValue,
  disabled,
  containerClassName,
  maxLength,
  counterClassName,
  ...textAreaProps
}: TextAreaWithLightTitleProps<TFieldValues, TName>) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue,
    disabled,
  });

  const valueLength = field.value?.length ?? 0;

  return (
    <WithLightTitle
      className={containerClassName}
      title={title}
      rightTitleComponent={
        <div className={classnames(styles.textLength, counterClassName)}>
          {maxLength
            ? `${valueLength}/${maxLength}${pluralFormat(maxLength ?? 0, 'caractère', true)}`
            : pluralFormat(valueLength ?? 0, 'caractère')}
        </div>
      }
    >
      <TextAreaComponent
        {...textAreaProps}
        {...field}
        value={field.value ?? ''}
        maxLength={maxLength}
        error={!!error}
      />
      <ErrorMessage error={error} />
    </WithLightTitle>
  );
};
